export default __webpack_public_path__ + "static/media/microChair.e4a0885e.png";